module.exports = __webpack_public_path__ + "distribution/img/yaoqing.991b491a.png";